/* ══ GripForge — Trimmer Shoulder Harness PDP ═══════════════════════════════
   Sibling of reach.js (the wrench page). Same architecture, same hard-won rules:

   · Prices come from Liquid via window.GF_HARNESS. NOTHING is priced in here, so
     the page can never disagree with checkout after a price edit in admin.
   · Pack tiers are REAL Shopify variants added as ONE line of quantity 1. The
     drawer stepper walks tiers by SWAPPING the variant and never raises the
     quantity — a line quantity of 2 is what trips the all-products quantity
     discount and mis-bills the cart.
   · Every control that changes the order writes to the REAL cart and re-syncs.
     Local state is not the cart; the redraw reads the server back.
   · Meta events go out through Shopify's customer event only. Calling fbq here
     as well double-counts — a shared eventID does NOT dedupe them.          */
(function(){
"use strict";
var $=function(s,c){return (c||document).querySelector(s)},
    $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))},
    money=function(n){return '$'+n.toFixed(2)};

var CFG = window.GF_HARNESS || null;
if(!CFG){ return; }

var LIVE=/gripforgeshop\.com|\.myshopify\.com|shopifypreview\.com/.test(location.hostname);
var TRASH='<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true">'+
 '<path fill="currentColor" d="M9 3h6a1 1 0 0 1 1 1v1h4v2H4V5h4V4a1 1 0 0 1 1-1Zm1 2h4V4h-4v1ZM6 9h12l-1 11a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L6 9Z"/></svg>';

var GIFT={
  ship :{t:'FREE Express Shipping',       img:'https://cdn.shopify.com/s/files/1/0804/8554/8286/files/Kaching-Bundles-images-removebg-preview.png'},
  w5   :{t:'FREE 5 Year Warranty',        img:'https://cdn.shopify.com/s/files/1/0804/8554/8286/files/Kaching-Bundles-hf_20260418_181258_b758e28a-d8e8-4873-9f74-fd0af75678a6-removebg-preview.png'},
  life :{t:'FREE Lifetime Warranty',      img:'https://cdn.shopify.com/s/files/1/0804/8554/8286/files/Kaching-Bundles-hf_20260419_190148-removebg-preview_430x_c3708d94-64c8-46ea-880c-650b0675950e.webp'},
  ebook:{t:'FREE "Gardeners Secret" eBook',img:'https://cdn.shopify.com/s/files/1/0804/8554/8286/files/Kaching-Bundles-hf_20260418_175904_23c0cb2a-8ae6-4813-b858-60ab868aa64f-removebg-preview.png'}
};
/* labels/badges are copy; every PRICE below comes from CFG */
var META=[
 {q:1,badge:'Starter',      name:'One Harness',           sub:'Take the weight off today.',
  label:'Save $20.00 Instantly!', gifts:[]},
 {q:2,badge:'Most Popular', name:'Two-Harness Bundle',    sub:'Buy one, get one 50% OFF.',
  label:'BUY 1, GET 1 50% OFF',   gifts:[GIFT.ship,GIFT.w5]},
 {q:3,badge:'Best Value',   name:'Three-Harness Bundle',  sub:'The crew set — or one to hand your neighbour.',
  label:'BUY 2, GET 1 FREE',      gifts:[GIFT.ship,GIFT.life,GIFT.ebook]}
];
var TIERS=META.map(function(m){
  var p=CFG.packs[m.q]||{};
  return {q:m.q, badge:m.badge, name:m.name, sub:m.sub, label:m.label, gifts:m.gifts,
          id:p.id, price:p.price, was:p.was, each:p.price? p.price/m.q : 0};
}).filter(function(t){return t.id});

var UPSELL=[
 {k:'ship', id:CFG.addons.ship, n:'Shipping Protection', s:'Loss, theft & damage', p:CFG.addons.shipPrice,
  img:'https://gripforgeshop.com/cdn/shop/files/checkmark_and_time-removebg-preview.png'},
 {k:'wty',  id:CFG.addons.wty,  n:'Lifetime Warranty',   s:'Free replacement, forever', p:CFG.addons.wtyPrice,
  img:'https://gripforgeshop.com/cdn/shop/files/hf_20260419_190148_9e72e7aa-ef87-4aee-bddf-75732cf7b82d-removebg-preview.png'}
];

var state={tier:1, cross:false, ship:false, wty:false, added:false};
var SHOPCART=null, cartBusy=false;

function T(){ for(var i=0;i<TIERS.length;i++) if(TIERS[i].q===state.tier) return TIERS[i]; return TIERS[0]; }
function isFree(k){
  var g=T().gifts.map(function(x){return x.t}).join(' ');
  return k==='wty' && /Lifetime Warranty/.test(g);
}

/* ── OFFER ──────────────────────────────────────────────────────────────── */
function drawBundles(){
  var el=$('#bundles'); if(!el) return;
  /* ⚠ THIS MARKUP IS A CONTRACT WITH gf-v6.css. The handle's card is
     .bnd > .bnd__ribbon + .bnd__row(.bnd__radio + .bnd__mid(.bnd__name/.bnd__sub/
     .bnd__lbl) + .bnd__px) + .bnd__gifts + .bnd__ups, and `.bnd[data-on="1"]`
     is what reveals the radio fill and the upsell row. Invent your own child
     names and every one of them renders as unstyled inline text running
     together on a single line — which is exactly what happened. */
  el.innerHTML=TIERS.map(function(b){
    var on=b.q===state.tier;
    return '<div class="bnd" data-q="'+b.q+'" data-on="'+(on?1:0)+'" role="radio" tabindex="0" aria-checked="'+on+'">'+
      '<span class="bnd__ribbon">'+b.badge+'</span>'+
      '<div class="bnd__row"><span class="bnd__radio"></span>'+
        '<span class="bnd__mid"><span class="bnd__name">'+b.name+'</span>'+
          (b.sub?'<span class="bnd__sub">'+b.sub+'</span>':'')+
          '<span class="bnd__lbl">'+b.label+'</span></span>'+
        '<span class="bnd__px"><b>'+money(b.price)+'</b><s>'+money(b.was)+'</s>'+
          '<em>'+money(b.each)+' each</em></span>'+
      '</div>'+
      (b.gifts.length? '<div class="bnd__gifts">'+b.gifts.map(function(g){
          return '<span><img src="'+g.img+'" alt="">+ '+g.t+'</span>'}).join('')+'</div>' : '')+
      (CFG.cross ? '<div class="bnd__ups"><img src="'+CFG.cross.img+'" alt="">'+
          '<span class="u-t">Add the '+CFG.cross.name+'?<small>'+money(CFG.cross.price)+
            ' <s>'+money(CFG.cross.was)+'</s> — '+CFG.cross.blurb+'</small></span>'+
          '<span class="chk" role="checkbox" aria-checked="'+(state.cross?'true':'false')+'" tabindex="0">✓</span>'+
        '</div>' : '')+
    '</div>';
  }).join('');
  $$('#bundles .bnd').forEach(function(b){
    b.addEventListener('click',function(e){
      if(e.target.closest('.chk')){ state.cross=!state.cross; drawBundles(); drawTotal(); return; }
      state.tier=+b.dataset.q; drawBundles(); drawAddons(); drawTotal();
    });
  });
}
function drawAddons(){
  var el=$('#addons'); if(!el) return;
  el.innerHTML=UPSELL.map(function(u){
    var free=isFree(u.k), on=free||state[u.k];
    return '<button class="addon" data-k="'+u.k+'" data-on="'+(on?1:0)+'" type="button"'+
      (free?' disabled aria-disabled="true"':'')+'>'+
      '<img src="'+(u.img||'')+'" alt="">'+
      '<span class="a-t">'+u.n+' <small>'+u.s+'</small></span>'+
      '<span class="a-p">'+(free?'<b class="a-free">FREE</b>':'+'+money(u.p))+'</span>'+
      '<span class="chk" role="checkbox" aria-checked="'+(on?'true':'false')+'">✓</span></button>';
  }).join('');
  $$('#addons .addon').forEach(function(a){
    if(a.disabled) return;
    a.addEventListener('click',function(){ state[a.dataset.k]=!state[a.dataset.k]; drawAddons(); drawTotal(); });
  });
}
function selectionTotal(){
  var t=T(), v=t.price;
  if(state.cross && CFG.cross) v+=CFG.cross.price;
  UPSELL.forEach(function(u){ if(state[u.k] && !isFree(u.k)) v+=u.p; });
  return Math.round(v*100)/100;
}
function drawTotal(){
  var t=T(), set=function(sel,v){var e=$(sel); if(e) e.textContent=v;};
  var sel=selectionTotal();
  var selWas=t.was + (state.cross&&CFG.cross?CFG.cross.was:0) +
    (state.ship&&!isFree('ship')?UPSELL[0].p:0) + (state.wty&&!isFree('wty')?UPSELL[1].p:0);
  var pct=Math.round((1-t.price/t.was)*100);
  set('#hPrice', money(t.price));
  var w=$('.was'); if(w) w.textContent=money(t.was);
  var sp=$('.savepill'); if(sp) sp.textContent='Save '+pct+'%';
  var gs=$('#galSave'); if(gs) gs.textContent='Save '+pct+'%';
  /* ⚠ "Your total" sits under the offer, so it prices the SELECTION — what you'd
     pay if you added it now. Pricing it from the CART shows $0.00 on every tier
     until something is added, which is exactly the bug the handle page had. */
  set('#tWas', money(selWas));
  set('#tNow', money(sel));
  set('#tSaved', "You're saving "+money(Math.max(0,selWas-sel))+' today');
  set('#atcPrice', money(sel));
  set('#stickyPrice', money(sel));
  var dc=$('#dCrossPx'); if(dc&&CFG.cross) dc.textContent='+'+money(CFG.cross.price);
}

/* ── CART ───────────────────────────────────────────────────────────────── */
function desiredLines(){
  var t=T(), o=[{id:t.id, quantity:1}];
  if(state.cross && CFG.cross) o.push({id:CFG.cross.id, quantity:1});
  UPSELL.forEach(function(u){ if(state[u.k] && !isFree(u.k)) o.push({id:u.id, quantity:1}); });
  return o;
}
function sync(){
  if(!LIVE) return Promise.resolve();
  return fetch('/cart.js',{headers:{Accept:'application/json'}})
    .then(function(r){return r.json()}).then(function(c){SHOPCART=c;})
    .catch(function(){SHOPCART=null;});
}
function packInfo(id){
  for(var i=0;i<TIERS.length;i++) if(TIERS[i].id===id) return {q:TIERS[i].q};
  return null;
}
function packIdFor(q){ for(var i=0;i<TIERS.length;i++) if(TIERS[i].q===q) return TIERS[i].id; return null; }

function trackAdd(lines){
  /* ONE source. Shopify's channel forwards this to every connected pixel. */
  try{ if(window.Shopify && Shopify.analytics && Shopify.analytics.publish)
    Shopify.analytics.publish('product_added_to_cart',{
      variantIds:lines.map(function(l){return String(l.id)}),
      value:selectionTotal(), currency:'USD'}); }catch(e){}
}
/* ⚠ SCROLL-LOCK ONLY BELOW 980px — THIS IS WHY THE GALLERY WENT BLANK ON ADD TO CART.
   gf-v6.css sets `.gal{position:sticky;top:80px}` above 980px and `position:static`
   below. Setting `overflow:hidden` on <body> turns body into a scroll container,
   and that SILENTLY KILLS position:sticky — so the moment the drawer opened, the
   desktop gallery column collapsed and the product images vanished behind it.
   Nothing was unloaded; the sticky element simply had nowhere to stick.
   gf-v6.js hit this exact bug on the handle page (Julian, 2026-08-07) and guards it
   the same way. The harness shipped without the guard; this ports it.
   Below 980px .gal is static so locking is safe — and on desktop the drawer is a
   side panel, so the page behind it does not need locking at all. */
var LOCK_BELOW=980;
function lockScroll(on){
  document.body.style.overflow = (on && window.innerWidth<=LOCK_BELOW) ? 'hidden' : '';
}
/* ⚠ THE SCRIM WAS NEVER BEING TURNED ON. gf-v6.css ships
   `.scrim{opacity:0;pointer-events:none}` and only `.scrim.on` reveals it, but this
   page added `.on` to the DRAWER and never to the scrim — so the backdrop never
   appeared, the page behind was never dimmed, and because the element keeps
   `pointer-events:none` the click-outside-to-close listener on it could never fire.
   The handle page does both (gf-v6.js openCart/closeCart); this matches it. */
function openCart(){
  var d=$('#drawer'), sc=$('#scrim');
  if(d) d.classList.add('on');
  if(sc) sc.classList.add('on');
  lockScroll(true);
}
function closeCart(){
  var d=$('#drawer'), sc=$('#scrim');
  if(d) d.classList.remove('on');
  if(sc) sc.classList.remove('on');
  lockScroll(false);
}
/* rotating a phone while the drawer is open must not strand the lock in the wrong
   state — recompute against the new width. */
addEventListener('resize',function(){
  var d=$('#drawer');
  lockScroll(!!(d && d.classList.contains('on')));
},{passive:true});

/* ⚠ WHY THE DRAWER LOOKED EMPTY ON OPEN.
   `i.image` from /cart.js is the product's FEATURED image at FULL SIZE. That used
   to be a 500x500 cutout, so it was instant — but the featured image is now the
   3712x4608 tailgate hero, ~4.7MB, and every cart line was pouring that into a
   44px thumbnail. Nothing was broken: the box just sat blank until megabytes
   finished downloading, on every single cart open. Ask the CDN for a thumbnail. */
function thumb(u,w){
  if(!u) return '';
  return u + (u.indexOf('?')>-1 ? '&' : '?') + 'width=' + (w||120);
}
function tierPrice(q){
  for(var i=0;i<TIERS.length;i++) if(TIERS[i].q===q) return TIERS[i].price;
  return 0;
}

function cartLines(){
  if(!(SHOPCART && SHOPCART.items && SHOPCART.items.length)) return [];
  return SHOPCART.items.map(function(i,ix){
    return {img:thumb(i.image,120), n:i.product_title,
            s:(i.variant_title && i.variant_title!=='Default Title')?i.variant_title:'',
            p:i.final_line_price/100,
            was:(i.original_line_price>i.final_line_price)?i.original_line_price/100:0,
            line:ix+1, qty:i.quantity, vid:i.variant_id, pack:packInfo(i.variant_id)};
  }).sort(function(a,b){                 /* the harness leads; add-ons follow */
    var ap=a.pack?0:1, bp=b.pack?0:1;
    return ap!==bp ? ap-bp : a.line-b.line;
  });
}
function drawDrawer(){
  var L=cartLines(), body=$('#dBody'); if(!body) return;
  body.innerHTML = L.length ? L.map(function(l){
    var ctl='';
    if(l.pack){
      /* ⚠ walks the PACK TIERS by swapping the variant. Never raises quantity —
         a line quantity of 2 is what trips the all-products quantity discount. */
      var prev=packIdFor(l.pack.q-1), next=packIdFor(l.pack.q+1);
      ctl='<span class="qty">'+
        (l.pack.q<=1
          ? '<button type="button" class="qty-del" data-line="'+l.line+'" aria-label="Remove">'+TRASH+'</button>'
          : '<button type="button" data-swap="'+l.vid+'" data-to="'+prev+'" aria-label="Fewer">−</button>')+
        '<b>'+l.pack.q+'</b>'+
        '<button type="button" data-swap="'+l.vid+'" data-to="'+(next||'')+'" aria-label="More"'+
          (next?'':' disabled')+'>+</button></span>'+
        '<button type="button" class="ci-rm" data-line="'+l.line+'">Remove</button>';
    } else {
      ctl='<span class="qty"><button type="button" class="qty-del" data-line="'+l.line+'" aria-label="Remove">'+
        TRASH+'</button><b>'+l.qty+'</b></span>'+
        '<button type="button" class="ci-rm" data-line="'+l.line+'">Remove</button>';
    }
    return '<div class="ci"><img src="'+(l.img||'')+'" alt="">'+
      '<span class="n">'+l.n+'<small>'+l.s+'</small>'+ctl+'</span>'+
      '<span class="p">'+money(l.p)+(l.was?'<s>'+money(l.was)+'</s>':'')+'</span></div>';
  }).join('') : '<p class="ci-empty">Your cart is empty.</p>';

  $$('#dBody [data-swap]').forEach(function(b){
    b.addEventListener('click',function(){ if(!b.disabled) swapPack(+b.dataset.swap,+b.dataset.to); });
  });
  $$('#dBody .qty-del,#dBody .ci-rm').forEach(function(b){
    b.addEventListener('click',function(){ changeLine(+b.dataset.line,0); });
  });

  var tot=SHOPCART?SHOPCART.total_price/100:0;
  var n=$('#dTotal'); if(n) n.textContent=money(tot);
  var wasTot=SHOPCART?(SHOPCART.items||[]).reduce(function(a,i){return a+i.original_line_price/100},0):0;
  var sv=$('#dSave'); if(sv) sv.textContent='–'+money(Math.max(0,wasTot-tot));
  var cnt=SHOPCART?SHOPCART.item_count:0;
  var c=$('#dCount'); if(c) c.textContent=cnt+(cnt===1?' item':' items');
  var hc=$('#cartCount'); if(hc) hc.textContent=cnt;

  /* ── gift-unlock progress ───────────────────────────────────────────────
     Ported from the handle page. The CSS (.drawer__ship*) already lives in
     gf-v6.css, so this only has to fill it in.

     ⚠ GATED ON THE GIFT TIERS, NEVER ON SHIPPING. Every GripForge order ships
     free already, so "$X away from free shipping" would be a fake gate for
     something the customer already has. Free shipping is stated flat and
     unconditionally in .drawer__ship-free underneath. Same rule as gf-v6.js. */
  var packQ=0;
  L.forEach(function(l){ if(l.pack && l.pack.q>packQ) packQ=l.pack.q; });
  var fill=$('#dShipFill'), msg=$('#dShipMsg'),
      t1=$('#dTier1'), t2=$('#dTier2');
  if(fill) fill.style.width=Math.min(100,Math.round(Math.min(packQ,3)/3*100))+'%';
  if(msg){
    var to2=Math.max(0,tierPrice(2)-tierPrice(1)),
        to3=Math.max(0,tierPrice(3)-tierPrice(2));
    msg.innerHTML =
      packQ<=1 ? '<b>'+money(to2)+'</b> away from a FREE 5 Year Warranty'
    : packQ===2 ? '\u2713 2 free gifts unlocked \u2014 <b>'+money(to3)+'</b> more for the Lifetime Warranty + eBook'
    :             '\uD83C\uDF81 <b>All 3 free gifts unlocked</b> \u2014 best price per harness';
  }
  if(t1) t1.classList.toggle('hit', packQ>=2);
  if(t2) t2.classList.toggle('hit', packQ>=3);

  /* drawer add-ons write to the REAL cart */
  var da=$('#dAddons');
  if(da){
    var inCart=function(id){ return !!(SHOPCART&&SHOPCART.items||[]).filter(function(i){return i.variant_id===id}).length; };
    da.innerHTML=UPSELL.map(function(u){
      var free=isFree(u.k), on=free||inCart(u.id);
      if(on && !free) return '';
      return '<button class="addon addon--cart" data-k="'+u.k+'" type="button"'+(free?' disabled':'')+'>'+
        '<img src="'+(u.img||'')+'" alt="">'+
        '<span class="a-t">'+u.n+' <small>'+u.s+'</small></span>'+
        '<span class="a-p">'+(free?'<b class="a-free">FREE</b>':'+'+money(u.p))+'</span>'+
        '<span class="chk" role="checkbox" aria-checked="'+(on?'true':'false')+'">✓</span></button>';
    }).join('');
    $$('#dAddons .addon').forEach(function(a){
      if(a.disabled) return;
      a.addEventListener('click',function(){
        var u=UPSELL.filter(function(x){return x.k===a.dataset.k})[0];
        if(u) setLine(u.id,1);
      });
    });
  }
  /* cross-sell inside the drawer */
  var dx=$('#dCross');
  if(dx && CFG.cross){
    var has=!!(SHOPCART&&(SHOPCART.items||[]).filter(function(i){return i.variant_id===CFG.cross.id}).length);
    dx.style.display=has?'none':'';
    dx.onclick=function(){ setLine(CFG.cross.id,1); };
  }
}
function writeCart(updates){
  if(cartBusy || !LIVE) return;
  cartBusy=true;
  var d=$('#drawer'); if(d) d.setAttribute('aria-busy','true');
  fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({updates:updates})})
   .then(function(r){return r.json()}).then(function(c){ SHOPCART=c; })
   .catch(function(){})
   .then(function(){ cartBusy=false; if(d) d.removeAttribute('aria-busy'); drawDrawer(); });
}
function setLine(id,qty){ var u={}; u[id]=qty; writeCart(u); }
function swapPack(oldId,newId){
  if(!newId) return;
  var u={}; u[oldId]=0; u[newId]=1;
  var pi=packInfo(newId); if(pi){ state.tier=pi.q; drawBundles(); drawAddons(); drawTotal(); }
  writeCart(u);
}
function changeLine(line,qty){
  if(cartBusy || !LIVE) return;
  cartBusy=true;
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({line:line,quantity:qty})})
   .then(function(r){return r.json()}).then(function(c){SHOPCART=c;})
   .catch(function(){})
   .then(function(){ cartBusy=false; drawDrawer(); });
}

var atc=$('#atc');
if(atc) atc.addEventListener('click',function(e){
  e.preventDefault();
  var lines=desiredLines();
  if(!LIVE){ alert('Local prototype — the Shopify cart is a different origin.\n\nWould add:\n'+
     lines.map(function(l){return '  variant '+l.id+' x'+l.quantity}).join('\n')); return; }
  atc.disabled=true;
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({items:lines})})
   .then(function(r){ if(!r.ok) return r.json().then(function(j){throw new Error(j.description||r.status)}); return r.json(); })
   .then(function(){ atc.disabled=false; trackAdd(lines); state.added=true;
                     return sync().then(function(){ drawDrawer(); openCart(); }); })
   .catch(function(err){ atc.disabled=false; alert('Could not add to cart: '+err.message); });
});
var sAtc=$('#stickyAtc'); if(sAtc) sAtc.addEventListener('click',function(){ atc && atc.click(); });
var oc=$('#openCart'); if(oc) oc.addEventListener('click',function(){ sync().then(function(){ drawDrawer(); openCart(); }); });
var cc=$('#closeCart'); if(cc) cc.addEventListener('click',closeCart);
var scrim=$('#scrim'); if(scrim) scrim.addEventListener('click',closeCart);
var dck=$('#dCheckout'); if(dck) dck.addEventListener('click',function(){ location.href='/checkout'; });

/* wallets: add, then hand off to Shopify's checkout (which fires its own events) */
$$('[data-wallet]').forEach(function(w){
  w.addEventListener('click',function(e){
    e.preventDefault(); if(!LIVE){ atc&&atc.click(); return; }
    var lines=desiredLines();
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:lines})})
     .then(function(){ trackAdd(lines); location.href='/checkout'; })
     .catch(function(){ location.href='/cart'; });
  });
});

/* ── GALLERY ────────────────────────────────────────────────────────────── */
var MEDIA=CFG.media||[];

/* Rendition picking. VERIFIED against the live render rather than assumed:
   storefront Liquid exposes only TWO sources for this video — the 1080p mp4 and
   an .m3u8 — even though the Admin API lists 480p/720p/1080p as well. So there is
   no smaller mp4 to fall back to here, and the real job of this function is to
   guarantee we never hand back the HLS manifest: Safari plays it from a bare src,
   Chrome and Firefox do not, so picking by array index fails silently on most
   traffic. mp4 only; smallest that still clears 720 tall; else the tallest mp4. */
function videoSrc(m){
  if(m.src) return m.src;                       /* older configs still inline one */
  var mp4=(m.srcs||[]).filter(function(s){ return s.f==='mp4' && s.u; });
  if(!mp4.length) return '';
  var big=mp4.filter(function(s){ return s.h>=720; })
             .sort(function(a,b){ return a.h-b.h; });
  if(big.length) return big[0].u;
  return mp4.sort(function(a,b){ return b.h-a.h; })[0].u;   /* else the tallest we have */
}
function drawGallery(i){
  var stage=$('#stage'); if(!stage||!MEDIA.length) return;
  state.slide=Math.max(0,Math.min(MEDIA.length-1,i));
  /* ⚠ PAUSE AND MUTE BEFORE DETACHING. Removing a <video> from the DOM does NOT
     stop it — verified in-browser: straight after .remove() the element still
     reports paused:false, muted:false. Once the gallery clip has sound turned on,
     swiping to the next slide would leave a voice talking from an element nobody
     can see, pause, or mute. Tear it down on the way out, and drop the src so the
     23MB download is abandoned too rather than finishing in the background. */
  $$('#stage img,#stage video').forEach(function(e){
    if(e.tagName==='VIDEO'){
      try{ e.pause(); e.muted=true; e.removeAttribute('src'); e.load(); }catch(_){}
    }
    e.remove();
  });
  var m=MEDIA[state.slide];
  /* ⚠ THE `on` CLASS IS LOAD-BEARING. gf-v6.css sets every direct child of
     .gal__stage to opacity:0 and only reveals `.gal__stage>.on`, because the
     handle's gallery cross-fades between stacked slides. Insert without it and
     the image loads perfectly and renders invisible — the stage just looks like
     an empty coloured box. */
  stage.insertAdjacentHTML('afterbegin', m.t==='vid'
    ? '<video class="on" src="'+videoSrc(m)+'" poster="'+(m.poster||'')+'" muted loop playsinline preload="none" autoplay></video>'
    : '<img class="on" src="'+m.src+'" alt="'+(m.alt||'')+'">');

  /* ── sound toggle for the gallery video ────────────────────────────────
     The button is appended to the STAGE, never to the slide, because the line
     above wipes and re-inserts the media element on every single slide change —
     a button living inside that markup would be destroyed with it and the
     listener would leak. The stage wipe only targets `img` and `video`, so this
     survives. Created once, then shown/hidden per slide. */
  if(MEDIA.some(function(x){return x.t==='vid';})){
    var snd=$('#galSnd');
    if(!snd){
      stage.insertAdjacentHTML('beforeend',
        '<button class="vid__snd gal__snd" id="galSnd" type="button" '+
        'aria-pressed="false" aria-label="Turn sound on" hidden>\uD83D\uDD07</button>');
      snd=$('#galSnd');
      snd.addEventListener('click',function(e){
        e.stopPropagation();                 /* the stage behind this toggles play */
        var v=$('#stage video'); if(!v) return;
        v.muted=!v.muted;
        if(!v.muted) muteStrip();            /* never two audio tracks at once */
        setSnd(this, v.muted);
        if(!v.muted){ var pr=v.play(); if(pr&&pr.catch) pr.catch(function(){}); }
      });
    }
    /* Only the video slide gets sound. Re-inserted video elements always start
       muted (the `muted` attribute is in the markup above), so reset the button
       to match rather than leaving a stale speaker-on icon. */
    snd.hidden = m.t!=='vid';
    setSnd(snd, true);
  }
  var dots=$('#dots');
  if(dots) dots.innerHTML=MEDIA.map(function(_,n){
    return '<button type="button" data-i="'+n+'" class="'+(n===state.slide?'on':'')+'" aria-label="Image '+(n+1)+'"></button>'}).join('');
  $$('#dots button').forEach(function(b){ b.addEventListener('click',function(){ drawGallery(+b.dataset.i); }); });
  var th=$('#trail');
  if(th) th.innerHTML=MEDIA.map(function(mm,n){
    return '<button type="button" data-i="'+n+'" class="'+(n===state.slide?'on':'')+'">'+
      '<img src="'+(mm.poster||mm.src||'')+'" alt="" loading="lazy"></button>'}).join('');
  $$('#trail button').forEach(function(b){ b.addEventListener('click',function(){ drawGallery(+b.dataset.i); }); });
}
var gp=$('#gPrev'), gn=$('#gNext');
if(gp) gp.addEventListener('click',function(){ drawGallery((state.slide-1+MEDIA.length)%MEDIA.length); });
if(gn) gn.addEventListener('click',function(){ drawGallery((state.slide+1)%MEDIA.length); });

/* ── video sound: shared helpers ─────────────────────────────────────────
   Both the gallery toggle above and the three clips below use these, so the
   icon/label/aria-pressed triple can never drift apart between the two. */
function setSnd(btn, muted){
  if(!btn) return;
  btn.textContent = muted ? '\uD83D\uDD07' : '\uD83D\uDD0A';
  btn.setAttribute('aria-pressed', String(!muted));
  btn.setAttribute('aria-label', muted ? 'Turn sound on' : 'Turn sound off');
}
function muteStrip(){
  $$('#hvids video').forEach(function(v){ v.muted=true; });
  $$('#hvids .vid__snd').forEach(function(b){ setSnd(b,true); });
}

/* ── the three UGC clips ─────────────────────────────────────────────────
   The markup is SERVER-RENDERED in gf-harness.liquid — this only enhances it.
   If none of this runs you still get three posters that play on tap, because a
   bare <video> does that on its own. */
var STRIP=$$('#hvids video');
if(STRIP.length){
  /* Play only what is actually on screen. Three clips autoplaying at once burns
     battery and data for no benefit, and preload="none" means nothing is fetched
     until we ask for it here. */
  if('IntersectionObserver' in window){
    var vio=new IntersectionObserver(function(es){
      es.forEach(function(e){
        var el=e.target;
        if(e.isIntersecting){
          if(!el.dataset.loaded){ el.load(); el.dataset.loaded='1'; }
          var pr=el.play(); if(pr&&pr.catch) pr.catch(function(){});   /* autoplay may be refused */
        } else {
          el.pause();
          if(!el.muted){ el.muted=true; setSnd(el.parentNode.querySelector('.vid__snd'), true); }
        }
      });
    },{threshold:0.35});
    STRIP.forEach(function(el){ vio.observe(el); });
  } else {
    STRIP.forEach(function(el){ el.load(); var pr=el.play(); if(pr&&pr.catch) pr.catch(function(){}); });
  }

  /* tap the clip to play/pause if the browser refused to autoplay it */
  STRIP.forEach(function(el){
    el.addEventListener('click',function(){
      if(el.paused){
        if(!el.dataset.loaded){ el.load(); el.dataset.loaded='1'; }
        el.play().catch(function(){});
      } else el.pause();
    });
  });

  /* Unmute — exactly ONE source audible at a time, the gallery video included.
     Clicking an already-on button turns it back off. */
  $$('#hvids .vid__snd').forEach(function(b){
    b.addEventListener('click',function(e){
      e.stopPropagation();                     /* the .vid behind this toggles play */
      var el=b.parentNode.querySelector('video'); if(!el) return;
      var turningOn=el.muted;
      muteStrip();
      var gv=$('#stage video');
      if(gv) gv.muted=true;
      setSnd($('#galSnd'), true);
      if(turningOn){
        el.muted=false;
        setSnd(b,false);
        if(el.paused){
          if(!el.dataset.loaded){ el.load(); el.dataset.loaded='1'; }
          el.play().catch(function(){});
        }
      }
    });
  });
}

/* ── FAQ ────────────────────────────────────────────────────────────────── */


/* ── FAQ ────────────────────────────────────────────────────────────────── */
var FAQS=[
 ['Will it fit my trimmer?','If your trimmer has a hanger loop on the shaft — nearly all string trimmers, brush cutters and edgers do — the carabiner clips straight to it. Nothing is fitted to the machine permanently.'],
 ['Does it work for gas and battery trimmers?','Yes. The harness carries the machine whatever powers it. Heavier gas units are where you feel the difference most.'],
 ['Is this just a strap?','No. A single strap hangs the machine off one shoulder, which trades a sore arm for a sore shoulder. This has two padded shoulder straps, a chest buckle, a back panel and a padded waist belt, so the load ends up on your hips and back.'],
 ['Will this help my back, or just my arms?','Mainly your arms, wrists and shoulders — it moves the machine\'s weight off your hands. If your problem is bending over to reach, that is what the GripForge™ Trimmer Handle is for. Plenty of people run both together.'],
 ['How long does it take to put on?','Two straps over the shoulders, clip the chest buckle, clip the waist belt, hook the trimmer on. No tools, nothing to install.'],
 ['Will it fit me?','Shoulder straps, chest strap and waist belt all adjust independently. <span class="need">Confirm the adjustment range.</span> If it does not fit, send it back inside 60 days.'],
 ['Can I use it with the GripForge™ Trimmer Handle?','Yes, and it is the most common setup — the handle fixes the angle so you stand straight, the harness takes the weight off your arms.'],
 ['Does the trimmer stay balanced?','The shaft rests on the padded hip pad and hangs from the carabiner, so it sits in one place instead of swinging. You slide the clip along the shaft to find the balance point once, then leave it.'],
 ['How fast does it ship?','Free shipping on every order. The 2 and 3 packs include free express shipping.'],
 ['What if I don\'t like it?','60-day money-back guarantee. Send it back and you get your money.']
];
var fl=$('#faqList');
if(fl){
  fl.innerHTML=FAQS.map(function(f,i){
    return '<div class="q" data-open="0"><button class="q__b" aria-expanded="false" aria-controls="a'+i+'">'+
      '<span class="ck">✓</span><span>'+f[0]+'</span><span class="cv">+</span></button>'+
      '<div class="q__p" id="a'+i+'"><p>'+f[1]+'</p></div></div>';
  }).join('');
  $$('#faqList .q__b').forEach(function(b){
    b.addEventListener('click',function(){
      var q=b.parentElement, pnl=b.nextElementSibling, open=q.dataset.open==='1';
      q.dataset.open=open?'0':'1';
      b.setAttribute('aria-expanded',open?'false':'true');
      pnl.style.maxHeight=open?'0px':pnl.scrollHeight+'px';
      var cv=b.querySelector('.cv'); if(cv) cv.textContent=open?'+':'–';
    });
  });
}

/* ── STOCK BAR ──────────────────────────────────────────────────────────── */
var sb=$('#stockBar'), spct=$('#stockPct');
if(sb&&spct) sb.style.width=spct.textContent.trim()+'%';


/* ── REVEAL ON SCROLL ───────────────────────────────────────────────────────
   The handle animates .rv blocks in as you scroll, via an observer in gf-v6.js.
   This page does not load that file, so we re-implement it here. Note the order:
   we only add .rv-anim (which is what allows anything to be hidden) at the very
   moment we are about to wire the observer. If this file never runs, .rv stays
   visible and the page just renders without the animation. */
try{
  var rvs=$$('.rv');
  if(rvs.length && 'IntersectionObserver' in window){
    document.documentElement.classList.add('rv-anim');
    var rio=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); rio.unobserve(e.target); } });
    },{threshold:.1, rootMargin:'0px 0px -40px'});
    rvs.forEach(function(el){ rio.observe(el); });
    /* belt and braces: anything still hidden after 2.5s gets shown regardless */
    setTimeout(function(){ rvs.forEach(function(el){ el.classList.add('in'); }); },2500);
  }
}catch(e){ document.documentElement.classList.remove('rv-anim'); }

/* ── STICKY ─────────────────────────────────────────────────────────────── */
var buy=$('.buy'), sticky=$('#sticky');
if(buy&&sticky) addEventListener('scroll',function(){
  sticky.classList.toggle('on', buy.getBoundingClientRect().bottom<0 && scrollY>600);
},{passive:true});

$$('[data-scroll]').forEach(function(b){
  b.addEventListener('click',function(){
    var t=document.querySelector(b.dataset.scroll); if(t) t.scrollIntoView({behavior:'smooth'});
  });
});

/* ── promo bar countdown + ticker ────────────────────────────────────────
   Ported from gf-v6.js so the harness wears the same furniture as the handle.
   All the CSS already exists in gf-v6.css; only this behaviour was missing. */

/* ⚠ THE CLONE IS LOAD-BEARING, NOT A NICETY. The animation is
   `@keyframes mq{to{transform:translateX(-50%)}}` — it slides the track by half
   its own width, which only reads as a seamless loop if the track holds EXACTLY
   TWO copies of the group. Ship one copy and the strip scrolls away to leave a
   visibly empty bar for half of every cycle. */
(function(){
  var t=$('#mq1');
  if(t && t.firstElementChild && t.children.length===1){
    t.appendChild(t.firstElementChild.cloneNode(true));
  }
})();

(function(){
  var h=$('#c-h'), m=$('#c-m'), sEl=$('#c-s');
  if(!h||!m||!sEl) return;
  /* Same localStorage key as the handle page ON PURPOSE. A visitor who clicks
     between the two products should not watch the countdown jump to a different
     number — that is the fastest way to make it read as fake. Shared key, so both
     pages always show the same clock. */
  var K='gf_deadline_v3', WINDOW=10*60*1000;
  function pad(n){ return String(n).padStart(2,'0'); }
  var end;
  try{ end=+localStorage.getItem(K); }catch(e){ end=0; }   /* private mode throws */
  if(!end || end<Date.now()){
    end=Date.now()+WINDOW;
    try{ localStorage.setItem(K,end); }catch(e){}
  }
  (function tick(){
    var d=Math.max(0, end-Date.now());
    if(d===0){
      end=Date.now()+WINDOW;
      try{ localStorage.setItem(K,end); }catch(e){}
      d=WINDOW;
    }
    var x=Math.floor(d/1000);
    h.textContent=pad(Math.floor(x/3600));
    m.textContent=pad(Math.floor(x/60)%60);
    sEl.textContent=pad(x%60);
    setTimeout(tick,1000);
  })();
})();

drawBundles(); drawAddons(); drawTotal(); drawGallery(0);
sync().then(drawDrawer);
})();
